/**
 * Brilheza cart drawer — fills gaps left by cart.api.js:
 *   - Shopify.changeItem / Shopify.removeItem were referenced (mini-cart's old
 *     delete button, cart.api.js's own template strings) but never defined.
 *   - No quantity-stepper wiring, no free-shipping bar, no cart:updated event,
 *     no AJAX interception of the product-page add-to-cart form.
 * Loads after cart.api.js / api.jquery.js, and overrides Shopify.onCartUpdate
 * so every existing call path (Shopify.addItem, addItemFromForm, ...) renders
 * through the same renderCart() function defined here.
 */
(function () {
  var DEBOUNCE_MS = 450;
  var debounceTimers = {};

  function formatMoney(cents) {
    return Shopify.formatMoney(cents, window.money_format);
  }

  function showError(message) {
    var box = document.querySelector('[data-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    clearTimeout(showError._t);
    showError._t = setTimeout(function () {
      box.hidden = true;
    }, 5000);
  }

  function lineItemMarkup(item) {
    var img = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, '_100x$1$2') : '';
    return (
      '<div class="mini-cart-item clearfix" data-line-item data-variant-id="' + item.variant_id + '">' +
        '<div class="mini-cart-img">' +
          '<a href="' + item.url + '">' +
            '<img src="' + img + '" width="100" height="100" alt="' + escapeHtml(item.title) + '" loading="lazy">' +
          '</a>' +
          '<button type="button" class="mini-cart-item-delete" data-cart-remove data-variant-id="' + item.variant_id + '" aria-label="Remove ' + escapeHtml(item.title) + '"><i class="icon-cancel"></i></button>' +
        '</div>' +
        '<div class="mini-cart-info">' +
          '<h6><a href="' + item.url + '">' + escapeHtml(item.title) + '</a></h6>' +
          '<span class="mini-cart-price">' + formatMoney(item.price) + '</span>' +
          '<div class="bh-mini-cart-qty" data-cart-qty-stepper>' +
            '<button type="button" class="bh-mini-cart-qty__btn" data-cart-qty-decrease data-variant-id="' + item.variant_id + '" aria-label="Decrease quantity">−</button>' +
            '<input type="number" class="bh-mini-cart-qty__input" data-cart-qty-input data-variant-id="' + item.variant_id + '" value="' + item.quantity + '" min="0" inputmode="numeric" aria-label="Quantity for ' + escapeHtml(item.title) + '">' +
            '<button type="button" class="bh-mini-cart-qty__btn" data-cart-qty-increase data-variant-id="' + item.variant_id + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderFreeShippingBar(cart) {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseFloat(bar.dataset.freeShippingThreshold);
    if (!threshold) return;
    var thresholdCents = threshold * 100;
    var remaining = thresholdCents - cart.total_price;
    var label = bar.querySelector('[data-free-shipping-label]');
    var fill = bar.querySelector('[data-free-shipping-fill]');
    if (label) {
      label.innerHTML = remaining > 0
        ? 'You\'re <strong>' + formatMoney(remaining) + '</strong> away from free shipping'
        : '🎉 You\'ve unlocked free shipping!';
    }
    if (fill) {
      var pct = Math.min(100, (cart.total_price / thresholdCents) * 100);
      fill.style.width = pct + '%';
    }
  }

  function renderCart(cart) {
    var itemsWrap = document.querySelector('[data-cart-items]');
    var emptyWrap = document.querySelector('.cart-empty-title');
    var footer = document.querySelector('[data-cart-footer]');

    if (itemsWrap) {
      itemsWrap.innerHTML = cart.items.map(lineItemMarkup).join('');
    }

    var hasItems = cart.item_count > 0;
    if (itemsWrap) itemsWrap.style.display = hasItems ? 'block' : 'none';
    if (footer) footer.style.display = hasItems ? 'block' : 'none';
    if (emptyWrap) emptyWrap.style.display = hasItems ? 'none' : 'block';

    document.querySelectorAll('.shopping-cart__total').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.querySelectorAll('.bigcounter').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    renderFreeShippingBar(cart);

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  // Fill the gap: nothing in cart.api.js / api.jquery.js defines these, despite
  // being referenced (mini-cart's delete button used to call Shopify.removeItem
  // directly and silently fail).
  Shopify.changeItem = function (variantId, quantity, lineItemEl) {
    if (lineItemEl) lineItemEl.classList.add('is-updating');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || e.message || 'Could not update cart'); });
        return res.json();
      })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function (err) {
        showError(err.message || 'Something went wrong updating your cart.');
        if (lineItemEl) lineItemEl.classList.remove('is-updating');
      });
  };

  Shopify.removeItem = function (variantId, lineItemEl) {
    Shopify.changeItem(variantId, 0, lineItemEl);
  };

  // Route every existing add-to-cart entry point (grid quick-add, product
  // page, predictive search) through the same render/refresh path.
  Shopify.onCartUpdate = function (cart) {
    renderCart(cart);
  };

  Shopify.onError = function (xhr) {
    var message = 'Something went wrong adding this to your cart.';
    try {
      var data = JSON.parse(xhr.responseText);
      message = data.description || (data.message ? data.message + ': ' + data.description : message);
    } catch (e) {}
    showError(message);
  };

  function debounced(key, fn) {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(fn, DEBOUNCE_MS);
  }

  document.addEventListener('click', function (e) {
    var decBtn = e.target.closest('[data-cart-qty-decrease]');
    var incBtn = e.target.closest('[data-cart-qty-increase]');
    var removeBtn = e.target.closest('[data-cart-remove]');

    if (decBtn || incBtn) {
      var btn = decBtn || incBtn;
      var lineItem = btn.closest('[data-line-item]');
      var input = lineItem.querySelector('[data-cart-qty-input]');
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + (incBtn ? 1 : -1));
      input.value = next;
      debounced(btn.dataset.variantId, function () {
        Shopify.changeItem(btn.dataset.variantId, next, lineItem);
      });
    }

    if (removeBtn) {
      var removeLineItem = removeBtn.closest('[data-line-item]');
      Shopify.removeItem(removeBtn.dataset.variantId, removeLineItem);
    }
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var lineItem = input.closest('[data-line-item]');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    debounced(input.dataset.variantId, function () {
      Shopify.changeItem(input.dataset.variantId, qty, lineItem);
    });
  });

  // Product page (and any other) form posting to /cart/add — go through
  // Shopify.addItem instead of a full-page reload, and open the drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (window.BrilhezaDrawer) window.BrilhezaDrawer.open('#ltn__utilize-cart-menu');
      })
      .catch(function (err) {
        showError(err.description || 'This item could not be added to your cart.');
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
})();
